// extracted by css-extract-rspack-plugin
export default {"root":"root-P3E4Mx","canvas":"canvas-rIfpOo","column":"column-G8DDOo"};